// forward Geocoding / reverse Geocoding
// Attributions: Along with all the individual attirbution (except Google and Bing)
// the openstreetMaps contribution has to be added, too!! And sometimes even a logo

const initialMapHostsData = [
  {
    id: 0,
    title: 'Nominatim',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    getKeyAtUrl: 'No key required.',
    description: 'Provides free reverse geocoding by searching OpenStreetMap data by name and address. Fair use: max. 1 request per second. Example page: https://nominatim.openstreetmap.org',
    url: 'https://nominatim.openstreetmap.org/reverse?format=json&lon={lon}&lat={lat}',
    appkey: '',
    attributions: '<a href="https://nominatim.org/copyright/" target="_blank">&copy; Carto</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 1,
    title: 'Bing Maps',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    getKeyAtUrl: 'https://www.bingmapsportal.com/',
    description: 'The free service allows for 125000 transactions per year.',
    url: '',
    appkey: 'AlhnFEKDaI3hXB0hi6p9Olyhpx9KuEfHnk5izYO0L-eBY7Pi7SAgzSDbe0MV28Uu',
    styles: [
      'RoadOnDemand',
      'Aerial',
      'AerialWithLabelsOnDemand',
      'CanvasDark',
      'OrdnanceSurvey'
    ],
    attributions: '<a href="https://www.bing.com/copyright/" target="_blank">&copy; Microsoft Bing</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 2,
    title: 'HERE Map Tiles',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    url: 'https://{1-4}.{base}.maps.cit.api.here.com/{type}/2.1/maptile/newest/{scheme}/{z}/{x}/{y}/256/png?app_id={app_id}&app_code={app_code}',
    appid: '',
    appkey: '',
    attributions: '<a href="https://www.here.com/copyright" target="_blank">&copy; HERE Map Tiles</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 3,
    title: 'Mapbox',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    getKeyAtUrl: 'https://mapbox.com/',
    description: '',
    url: 'https://{a-d}.tiles.mapbox.com/v4/mapbox.mapbox-streets-v6/{z}/{x}/{y}.vector.pbf?access_token=', // + appkeykey',
    appkey: 'pk.eyJ1Ijoicm93aWxkIiwiYSI6ImNrZW1yd3p2bjNjbG0yem1pMXQybzNxeWoifQ.iftB4KYXyXdlMQ6jtbFtbQ',
    attributions: '<a href="https://www.mapbox.com/map-feedback/" target="_blank">&copy; MapBox</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 4,
    title: 'Maptiler',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    getKeyAtUrl: 'https://www.maptiler.com/cloud/',
    description: '',
    url: 'https://api.maptiler.com/maps/outdoor/256/{z}/{x}/{y}@2x.png?key=', // + appkeykey',
    appkey: '',
    attributions: '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 5,
    title: 'Carto',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    getKeyAtUrl: 'https://carto.com/',
    description: '',
    url: 'https://{s}.basemaps.cartocdn.com/{style}/{z}/{x}/{y}{scale}.png', // @src https://github.com/CartoDB/basemap-styles
    appkey: '',
    attributions: '<a href="https://carto.com/copyright/" target="_blank">&copy; Carto</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  },
  {
    id: 6,
    title: 'Stamen',
    type: 'base', // prepare for ol-layerswitcher, which needs "title" and "type" params
    getKeyAtUrl: 'http://maps.stamen.com/',
    description: '',
    url: 'https://{s}.basemaps.cartocdn.com/{style}/{z}/{x}/{y}{scale}.png', // @src https://github.com/CartoDB/basemap-styles
    appkey: '',
    attributions: '<a href="https://carto.com/copyright/" target="_blank">&copy; Carto</a>',
    active: false,
    createdAt: Date.now(),
    updatedAt: null
  }

]

export default initialMapHostsData
